import { Controller } from "@hotwired/stimulus"

// A duty's side pane (playbook/_duty_pane): the title and "How it's done" turn
// into their forms on a click, and the rhythm and department selects save as
// soon as they change. Each form posts to PlaybookController#update_duty,
// which brings the register back with this pane open.
export default class extends Controller {
    static targets = ["titleView", "titleForm", "descriptionView", "descriptionForm"]

    editTitle() {
        this._swap(this.titleViewTarget, this.titleFormTarget)
    }

    cancelTitle() {
        this._swap(this.titleFormTarget, this.titleViewTarget)
    }

    editDescription() {
        this._swap(this.descriptionViewTarget, this.descriptionFormTarget)
    }

    cancelDescription() {
        this._swap(this.descriptionFormTarget, this.descriptionViewTarget)
    }

    submit(event) {
        event.target.form?.requestSubmit()
    }

    _swap(from, to) {
        from.hidden = true
        to.hidden = false
        let field = to.querySelector("input[type=text], textarea")
        if (field) {
            field.focus()
            if (field.tagName === "INPUT") field.select()
        }
    }
}
